<template>
  <Content id="School">
    <div slot="search">
      <Form :label-width="45" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="微信标识" :label-width="70"><Input v-model="search.openid" style="width: 250px;"/></FormItem></Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">
      <el-table-column fixed align="center" prop="openid" label="微信标识" min-width="200"/>
<!--      <el-table-column align="center" prop="deviceModel" label="设备模型" min-width="130"/>-->
      <el-table-column align="center" prop="remarks" label="备注" min-width="130"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="60" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button>
          <el-popover placement="top" min-width="150" v-model="deleteVisible['visible_' + row.id]">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 35px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: red;"/>是否确定删除？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="del(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">删除</a>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
           show-elevator show-sizer show-total @on-change="chagecurrent"
           :page-size-opts="[10, 30, 50, 100]"
           @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <BlackListEdit ref="edit" @on-submit="handleSubmit"/>
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import { _selectPages, _updateStatus, _delete} from "@/services/manage/blackList";
import BlackListEdit from "./BlackListEdit";
export default {
  name: "BlackList",
  components: {
    BlackListEdit
  },
  data() {
    return {
      tableHeight: 0,
      currentRowIndex: null,
      search: {
        ip: "",
        openid: "",
        status:1
      },
      deleteVisible:{},
      editWindow:false,
      windowTitle:"新增",
      dataList: [],
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
      this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _selectPages({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode === 1 && res.data && res.data.records && res.data.records.length > 0) {
          res.data.records.forEach(item => {
            this.deleteVisible['visible_' + item.id] = false;
          })
        }

        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    async handleCreate() {
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs['edit'].handleModal(row);
    },
    cancel(){
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
    },
    del(row) {
      _delete({id: row.id}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.handleDataList();
          this.$message.success("删除成功")
        }else{
          this.$message.error(res.errmsg)
        }
      })
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-table .el-table__cell {padding: 11px 0;}

</style>
